import React, { h } from 'preact'
import { useContext, useEffect, useMemo, useState } from 'preact/hooks'

import { WidgetConfigContext } from 'grosella/context'
import { TenantContext } from 'grosella/context/tenant-provider'
import {
    Box,
    Title,
    WidgetFrame,
    Message,
    Button,
    PoweredBy,
} from 'grosella/components/atoms'
import { SearchFrame } from 'grosella/components/molecules'
import { IntegrationType } from 'grosella/types'
import { fetchOptionalFeatures } from 'grosella/utils/fetch-optional-features'

export const SearchWidget: React.FunctionalComponent = (props) => {
    const widgetConfig = useContext(WidgetConfigContext)
    const tenant = useContext(TenantContext)
    const [optionalFeatures, setOptionalFeatures] = useState({
        hidePoweredByLogixboard: false,
        showMbl: false,
    })
    const goToSignup = (): void => {
        window.location.href = widgetConfig.urlPrefix
            ? `https://${tenant.domainName}/signUp`
            : 'https://www.logixboard.com'
    }

    const portalName = widgetConfig.portalName
    const title = `Do More, See More, Ship More${
        portalName ? ` with ${portalName}` : ''
    }`

    const subTitle =
        tenant?.integrationType === IntegrationType.CARGOWISE
            ? `Track and save shipments, check customs statuses, view
    invoices and documents and more when you sign up for an
    account.`
            : `Quickly find and track your shipments at anytime. Request your account today!`

    useEffect(() => {
        if (tenant?.id) {
            fetchOptionalFeatures(tenant?.id).then(setOptionalFeatures)
        }
    }, [tenant])

    const shouldShowPoweredByLogixboard = useMemo(() => {
        return (
            widgetConfig.variant === 'large' &&
            !optionalFeatures?.hidePoweredByLogixboard
        )
    }, [widgetConfig, optionalFeatures])

    return (
        <WidgetFrame variant={widgetConfig.variant}>
            <SearchFrame shouldShowMbl={optionalFeatures.showMbl} />
            <Box
                display="flex"
                flexDirection="column"
                padding="12px 16px"
                alignItems={
                    widgetConfig.variant === 'large' ? 'center' : undefined
                }
            >
                <Title variant={widgetConfig.variant}>{title}</Title>

                <Message variant={widgetConfig.variant}>{subTitle}</Message>
                <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-between"
                    alignItems="center"
                    padding={
                        widgetConfig.variant === 'large' ? '24px 0' : '10px 0'
                    }
                >
                    <Button backgroundColor="#F5F5F5" onClick={goToSignup}>
                        Get Your Account Now
                    </Button>
                    {widgetConfig.variant === 'compact' && (
                        <PoweredBy></PoweredBy>
                    )}
                </Box>
                {shouldShowPoweredByLogixboard && <PoweredBy></PoweredBy>}
            </Box>
        </WidgetFrame>
    )
}
